import { call, put, take, race, takeLatest } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import { loginApi, refreshAuth } from './login.api';
import { userLoggedIn, userLoginFail } from '../../../common/actions/auth.actions';
import { storageAuthToken, storageRoles, storageAuthInformation, XSRFToken, groupAuthInformation } from '../../../common/constants/strings';
import { loginActions, logoutActions } from './login.actions';

import { TokenDto, LoginDto } from './login.dtos';
import { AuthDto, authInit } from '../../../common/dtos/auth.dtos';

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const getCookie = () => {
  var cookie = document.cookie.split(';').find(strCookie => strCookie.indexOf(XSRFToken) >= 0);
  if (cookie != null) {
    return cookie.trim().substring(XSRFToken.length + 1);
  }
  return "";
}

function* authorize(creds: LoginDto) {
  try {
    const token: TokenDto = yield call(loginApi, creds);


    if (token.authToken && token.authToken.length > 0) {
      const auth: AuthDto = {
        authToken: token.authToken,
        isAdmin: Boolean(token.roles.find((r: string) => r === "admin")),
        isAuthenticated: true,
        refreshToken: token.refreshToken,
        roles: token.roles,
        fullName: token.fullName,
        userId: token.userId
      }

      sessionStorage.setItem(XSRFToken, getCookie());
      sessionStorage.setItem(storageAuthToken, token.authToken);
      sessionStorage.setItem(storageRoles, JSON.stringify(token.roles));
      sessionStorage.setItem(storageAuthInformation, JSON.stringify(token));
      sessionStorage.setItem(groupAuthInformation, token.userId);


      yield put({ type: getType(userLoggedIn), payload: auth });

      return token;
    }
    else {
      put({ type: getType(userLoginFail), payload: "Login Failed" });
    }

  }
  catch (error) {
    console.log(error);
    console.log("NO LOGIN");
    put({ type: getType(userLoginFail), payload: "Login Failed" });
  }

}

function* loginAndRefreshToken(creds: ReturnType<typeof loginActions.request>) {
  const token: TokenDto = yield call(authorize, creds.payload);

  if (token !== undefined && token.expiresIn !== undefined && token.refreshToken !== undefined) {
    while (true) {
      yield call(delay, token.expiresIn);
      const newToken: TokenDto = yield call(refreshAuth, token.refreshToken);

      if (newToken.authToken && newToken.authToken.length > 0) {
        const auth: AuthDto = {
          authToken: newToken.authToken,
          isAdmin: Boolean(newToken.roles.find((r: string) => r === "admin")),
          isAuthenticated: true,
          refreshToken: newToken.refreshToken,
          roles: newToken.roles,
          fullName: newToken.fullName,
          userId: newToken.userId
        }

        sessionStorage.setItem(XSRFToken, getCookie());
        sessionStorage.setItem(storageAuthToken, newToken.authToken);
        sessionStorage.setItem(storageRoles, JSON.stringify(newToken.roles));
        sessionStorage.setItem(storageAuthInformation, JSON.stringify(newToken));

        yield put({ type: getType(userLoggedIn), payload: auth });
      }
      else {
        put({ type: getType(userLoginFail), payload: "Unauthorized" });
      }
    }
  }
}

function* handleLogout() {
  yield put({ type: getType(userLoggedIn), payload: authInit });

  sessionStorage.removeItem(XSRFToken);
  sessionStorage.removeItem(storageAuthToken);
  sessionStorage.removeItem(storageRoles);
  sessionStorage.removeItem(storageAuthInformation);
  sessionStorage.clear();

  window.location.assign("/login");
}

export function* watchLoginRequest() {
  try {
    while (true) {
      const creds = yield take(getType(loginActions.request));
      yield race([
        take(getType(logoutActions.request)),
        call(loginAndRefreshToken, creds),
      ]);
    }
  }
  catch (err) {
    console.log(err);
  }
}

export function* watchLogoutRequest() {
  yield takeLatest(getType(logoutActions.request), handleLogout);
}